export const throttle = <TArgs extends unknown[]>(
  fn: (...args: TArgs) => void,
  delay: number,
): ((...args: TArgs) => void) => {
  let timer: ReturnType<typeof setTimeout> | undefined;
  return (...args: TArgs) => {
    clearTimeout(timer);
    timer = setTimeout(() => fn.apply(this, args), delay);
  };
};
